export default {
  theme: null,
  cookieBanner: null,
  showCookieConsent: false
};
